'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _next = require('@alifd/next');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('./util');

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Popup = _next.Overlay.Popup;


var LinkageSelect = function LinkageSelect(props) {
  var disabled = props.disabled,
      className = props.className,
      handleAdd = props.handleAdd,
      _props$superProps = props.superProps,
      superProps = _props$superProps === undefined ? {} : _props$superProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      showData = _useState4[0],
      setShowData = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      originData = _useState6[0],
      setOriginData = _useState6[1];

  var updateData = function updateData() {
    var data = (0, _util.getLinkageShareData)(superProps);
    if (JSON.stringify(data) !== JSON.stringify(originData)) {
      setShowData(data);
      setOriginData(data);
    }
  };

  (0, _react.useEffect)(function () {
    if (visible) {
      updateData();
    }
  }, [superProps, visible]);

  var clickOk = function clickOk() {
    var totalData = showData.map(function (item) {
      return item.shareData;
    });
    var selectData = null;
    totalData.forEach(function (item) {
      item.forEach(function (i) {
        if (i.selected) {
          delete i.selected;
          delete i.labelList;
          selectData = i;
        }
      });
    });
    if (selectData) {
      handleAdd(selectData);
    }
    setVisible(false);
  };

  var clickItem = function clickItem(parentIndex, itemIndex) {
    // item.selected = !item.selected;
    showData.forEach(function (item, index) {
      item.shareData.forEach(function (i, iIndex) {
        if (parentIndex === index && itemIndex === iIndex) {
          i.selected = !i.selected;
        } else {
          i.selected = false;
        }
      });
    });
    setShowData([].concat(_toConsumableArray(showData)));
  };

  var clickGroup = function clickGroup() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    item.open = !item.open;
    setShowData([].concat(_toConsumableArray(showData)));
  };

  var trigger = _react2.default.createElement(
    _next.Button,
    {
      type: 'secondary',
      disabled: disabled,
      onClick: function onClick() {
        setVisible(true);
      },
      className: 'selectDataBtn ' + className
    },
    _react2.default.createElement(_next.Icon, { type: 'copy' }),
    "选择数据"
  );

  return _react2.default.createElement(
    Popup,
    { trigger: trigger, triggerType: 'click', visible: visible, wrapperClassName: 'popupWrapper',
      onVisibleChange: function onVisibleChange(visible) {
        setVisible(visible);
      }
    },
    _react2.default.createElement(
      'div',
      { className: 'popupContent' },
      showData.length ? _react2.default.createElement(
        'div',
        { className: 'listBox' },
        showData.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(
              'div',
              { className: 'item groupItem', onClick: function onClick() {
                  return clickGroup(item);
                } },
              _react2.default.createElement('div', { className: '' + (item.open ? 'arrowDown' : 'arrowRight') }),
              _react2.default.createElement(
                'div',
                { className: 'content itemTitle' },
                '\u6570\u636E\u6765\u6E90\uFF1A',
                item.label
              )
            ),
            item.open ? _react2.default.createElement(
              'div',
              null,
              (item.shareData || []).map(function (textItem, textIndex) {
                return _react2.default.createElement(
                  'div',
                  { key: textIndex, className: 'item dataItem', onClick: function onClick() {
                      return clickItem(index, textIndex);
                    } },
                  textItem.selected ? _react2.default.createElement('div', { className: 'checkbox checked' }) : _react2.default.createElement('div', { className: 'checkbox' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    (textItem.labelList || []).map(function (text, i) {
                      return _react2.default.createElement(
                        'div',
                        { key: i, className: 'contentItem' },
                        text
                      );
                    })
                  )
                );
              })
            ) : null
          );
        })
      ) : _react2.default.createElement(
        'div',
        { className: 'nodataBox' },
        '\u6682\u65E0\u53EF\u9009\u6570\u636E'
      ),
      _react2.default.createElement(
        'div',
        { className: 'buttonBox' },
        _react2.default.createElement(
          _next.Button,
          { type: 'normal', className: 'cancelBtn', onClick: function onClick() {
              return setVisible(false);
            } },
          '\u53D6\u6D88'
        ),
        _react2.default.createElement(
          _next.Button,
          { type: 'primary', onClick: clickOk },
          '\u786E\u5B9A'
        )
      )
    )
  );
};

exports.default = LinkageSelect;
module.exports = exports['default'];